// Item library evaluate codes for /roads-sewers/main-services-substation's
// Substation Base tab dev-mode display — mirrors mainServicesEvaluateCodesMapping.ts's
// description -> code lookup pattern. The Substation Base/Access tables look their
// rows up here by description rather than hardcoding codes inline, so codes stay
// in one place as more are added.

export interface SubstationBaseEvaluateCodeItem {
  description: string;
  code: string;
}

export const SUBSTATION_BASE_EVALUATE_CODES: SubstationBaseEvaluateCodeItem[] = [
  { description: 'Setting out Engineer', code: 'APRE022' },
];

export function findSubstationBaseEvaluateCode(description: string): string | undefined {
  return SUBSTATION_BASE_EVALUATE_CODES.find((i) => i.description === description)?.code;
}
